import { LifeIdDrawer } from '@components/ui';
import styled from 'styled-components';
import theme from '../../../../constants/theme';

export const LifeChartSC = styled(LifeIdDrawer.Header)`
  .lc-legend-item {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.3;
    margin-bottom: 8px;

    .lc-dot {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      margin-right: 8px;
      background: #47507a;

      &.is-primary {
        background: ${theme.colors.primary};
      }

      &.is-success {
        background: ${theme.colors.success};
      }
    }
  }

  .records {
    width: 100%;
    text-align: right;
    margin-top: -15px;
    margin-bottom: 16px;
    opacity: 0.4;
  }
` as typeof LifeIdDrawer.Header;

type TVitalLegendDotSC = {
  color: string;
};
export const VitalLegendDotSC = styled.div<TVitalLegendDotSC>`
  width: 14px;
  height: 14px;
  border-radius: 7px;
  margin-right: 8px;
  background: ${({ color }) => color};
`;
